class NaturezaController extends AbstractController
  @$inject = [ '$injector', 'pathService', 'naturezaService' ]

  constructor: ($injector, pathService, @naturezaService) ->
    super($injector)
    
    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/pis-cofins/natureza/"
    @loadingTracker = @promiseTracker()
    @modalNatureza = @openPopup(@url + "modal.html", 'naturezaModalController as ctrl')
    @modalImportar = @openPopup(@url + "importar.html", 'naturezaImportarController as ctrl')

    @filtro =
      page: 1
      estado: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadData()

  loadData: (page = 1)->
    filtro = angular.copy @filtro
    filtro.page = page
    @loadingTracker.addPromise @naturezaService.getList(filtro,(result) =>
      if result.success
        @listOfNatureza = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar naturezas.', 'Erro!', false)
    )

  add: ->
    @modalNatureza({
      natureza: => {}
    }, (result) =>
      @loadData())

  edit: (natureza) ->
    @modalNatureza({
      natureza: => natureza
    }, (result) =>
      @loadData())

  baixar: () ->
    cbk.download '/api/eficiencia-fiscal/natureza.csv'

  importar: ->
    @modalImportar({}, (result) =>
      @loadData()
    )

  remover: (natureza)->
    @Confirm.warning('Atenção', "Deseja realmente remover a natureza ##{natureza.descricao}?", {
      Sim: =>
        @naturezaService.delete(natureza.id, (result)=>
          if(result.success)
            Alert.success("A natureza #{natureza.descricao} foi removida!.", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover a natureza #{natureza.descricao}.")
        )
      Não: ''
    })


angular.module('eficienciaFiscalModule').controller('naturezaController', NaturezaController)

class NaturezaModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'naturezaService', 'natureza' ]

  constructor: ($injector, @modalInstance, @naturezaService, @natureza, @listOfEstado, @listOfOperacao) ->
    super($injector)

    @submitTracker = @promiseTracker()

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @naturezaService.save(@natureza, (data) =>
        Alert.success("Natureza  <strong>#{data.descricao}</strong> #{if @natureza.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('naturezaModalController', NaturezaModalController)


class NaturezaImportarController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader' ]

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/eficiencia-fiscal/natureza"

    @uploader = new FileUploader(
      url: @url
      headers: cbk.getHeaders()
      filters: [ {
        name: 'extFilter'
        fn: (item, options) =>
          extension = item.type == 'text/csv' || item.type == "application/vnd.ms-excel"
          @extension = !extension
          @uploader.clearQueue() unless extension
          document.getElementById('file').value = '' unless extension

          return extension
      } ]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>

      if response.success
        @Alert.success("O CSV de natureza foi importado com sucesso.", 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

angular.module('eficienciaFiscalModule').controller('naturezaImportarController', NaturezaImportarController)